<template>
  <span class="icon">
    <svg v-if="iconConfig" :width="size" :height="size" :aria-label='alt' 
      v-bind="ariaHidden ? { 'aria-hidden': ariaHidden, focusable: !ariaHidden } : {}"
      role="img" :viewBox="iconConfig.viewBox" :fill="fill">
      <path :d="iconConfig.path"></path>
    </svg>
  </span>
</template>

<script>
import { defineComponent } from 'vue';

import { icons, iconsBrand } from '@/assets/icons'

const setIcons = {
  icons,
  brand: iconsBrand,
}

export default defineComponent({
  props: {
    set: {
      type: String,
      default: 'icons',
    },
    name: {
      type: String,
      required: true,
    },
    size: {
      type: [String, Number],
      default: '1em',
    },
    alt: {
      type: String,
      default: undefined,
    },
    ariaHidden: {
      type: Boolean,
      default: false,
    },
    fill: {
      type: String,
      default: 'currentColor',
    }
  },

  computed: {
    iconConfig() {
      return setIcons[this.set][this.name]
    },
  },
});
</script>

<style lang="scss" scoped>
.icon {
  @apply inline-block;
}
</style>
